// extracted by mini-css-extract-plugin
export var button = "_a2-0";
export var icon = "_a2-1";